/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`It is the dilution equation. Because diluting a solution does not change the number of moles of solute, concentration multiplied by volume is equal before and after dilution.`)
};

const es_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es la ecuación de dilución. Como diluir una solución no cambia el número de moles de soluto, la concentración multiplicada por el volumen es igual antes y después de la dilución.`)
};

const de_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das ist die Verdünnungsgleichung. Da eine Verdünnung die Stoffmenge des gelösten Stoffes nicht verändert, ist Konzentration mal Volumen vor und nach der Verdünnung gleich.`)
};

const nl_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit is de verdunningsvergelijking. Omdat het verdunnen van een oplossing het aantal mol opgeloste stof niet verandert, is concentratie vermenigvuldigd met volume vóór en na verdunning gelijk.`)
};

const fr_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`C'est l'équation de dilution. Comme la dilution d'une solution ne change pas le nombre de moles de soluté, la concentration multipliée par le volume est égale avant et après dilution.`)
};

const it_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È l'equazione di diluizione. Poiché diluire una soluzione non cambia il numero di moli di soluto, la concentrazione moltiplicata per il volume è uguale prima e dopo la diluizione.`)
};

const pt_br2_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a equação de diluição. Como diluir uma solução não altera o número de mols de soluto, a concentração multiplicada pelo volume é igual antes e depois da diluição.`)
};

const pt_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É a equação de diluição. Como diluir uma solução não altera o número de moles de soluto, a concentração multiplicada pelo volume é igual antes e depois da diluição.`)
};

const ja_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`希釈の式です。溶液を希釈しても溶質のモル数は変化しないため、希釈前後で濃度×体積は等しくなります。`)
};

const zh_soldil_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是稀释方程。由于稀释溶液不会改变溶质的摩尔数，稀释前后浓度乘以体积的值相等。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const soldil_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.soldil_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("soldil_faq_a1", locale)
	if (locale === "en") return en_soldil_faq_a1(inputs)
	if (locale === "es") return es_soldil_faq_a1(inputs)
	if (locale === "de") return de_soldil_faq_a1(inputs)
	if (locale === "nl") return nl_soldil_faq_a1(inputs)
	if (locale === "fr") return fr_soldil_faq_a1(inputs)
	if (locale === "it") return it_soldil_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_soldil_faq_a1(inputs)
	if (locale === "pt") return pt_soldil_faq_a1(inputs)
	if (locale === "ja") return ja_soldil_faq_a1(inputs)
	return zh_soldil_faq_a1(inputs)
};